import * as actionType from "./action";

export function alertsReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_ALERTS_SUCCESS:
      return { ...state, response };
    case actionType.GET_ALERTS_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}
